import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-menu',
  templateUrl: './demo-menu.component.html',
  styleUrls: ['./demo-menu.component.less']
})
export class DemoMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
